import { message, Spin, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  createOAuthCallbackStoragePayload,
  decodeOAuthState,
  getOAuthCallbackStorageKey,
  readOAuthCallbackParams,
} from '@/services/oauthWebSession';
import { authStore } from '@/stores';

export function LoginCallbackPage() {
  const navigate = useNavigate();
  const [popupStatus, setPopupStatus] = useState<'pending' | 'complete'>(
    'pending',
  );
  const openedFromPopup =
    typeof window !== 'undefined' &&
    Boolean(window.opener) &&
    !window.opener.closed;

  useEffect(() => {
    let cancelled = false;

    void (async () => {
      if (openedFromPopup) {
        try {
          const params = readOAuthCallbackParams(window.location.href);
          if (!params.state) {
            throw new Error('登录回调缺少状态参数');
          }
          const { flowID } = decodeOAuthState(params.state);
          window.localStorage.setItem(
            getOAuthCallbackStorageKey(flowID),
            JSON.stringify(
              createOAuthCallbackStoragePayload({
                flowID,
                callbackURL: window.location.href,
                receivedAt: Date.now(),
              }),
            ),
          );
          setPopupStatus('complete');
          window.close();
          return;
        } catch (error) {
          if (!cancelled) {
            const errorMsg =
              error instanceof Error ? error.message : '登录回调通知失败';
            message.error(errorMsg);
          }
        }
      }

      try {
        const returnPath = await authStore.completeOAuthCallback(
          window.location.href,
        );
        if (!cancelled) {
          message.success('登录成功');
          navigate(returnPath, { replace: true });
        }
      } catch (error) {
        if (!cancelled) {
          const errorMsg = error instanceof Error ? error.message : '登录失败';
          message.error(errorMsg);
          navigate('/', { replace: true });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate, openedFromPopup]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6">
      <div className="flex flex-col items-center gap-4 text-center">
        <Spin size="large" />
        <Typography.Title level={4} style={{ margin: 0 }}>
          {openedFromPopup && popupStatus === 'complete'
            ? '授权已完成'
            : openedFromPopup
              ? '正在返回登录页'
              : '正在完成登录'}
        </Typography.Title>
        <Typography.Text type="secondary">
          {openedFromPopup && popupStatus === 'complete'
            ? '授权结果已经返回给主页面，如果窗口未自动关闭，可以直接手动关闭。'
            : openedFromPopup
              ? '请稍候，我们正在把授权结果通知给原窗口。'
              : '请稍候，我们正在校验授权结果并恢复会话。'}
        </Typography.Text>
      </div>
    </div>
  );
}
